function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.564,
    height: 40,
    viewBox: "0 0 36.564 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.032)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M63.834.629A3.921,3.921,0,0,0,60.8.1L78.844,18.146,84.691,12.3Z",
    transform: "translate(-60.802 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.572)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M22.784,20.116a3.92,3.92,0,0,0-.793,2.359V54.613a3.921,3.921,0,0,0,.793,2.359L41.212,38.544Z",
    transform: "translate(-21.991 -20.116)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.927 13.629)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M327.077,177.39l-5.255-2.94-6.371,6.371,6.371,6.371,5.256-2.941a3.931,3.931,0,0,0,0-6.861Z",
    transform: "translate(-315.451 -174.45)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.033 21.852)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M78.855,279.711l-18.04,18.04a3.894,3.894,0,0,0,3.031-.523L84.7,285.558Z",
    transform: "translate(-60.815 -279.711)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.79387165ec270faf24a507355614a77f.svg";
export { ForwardRef as ReactComponent };